
export enum ModuleFormat {
    // face-to-face курсы
    // онлайн курсы
    Default = 0,
    PreRecorded = 1,
    // офлайн-курсы
    Offline = 2
}
export enum ModuleFormat {
    // face-to-face курсы
    // онлайн курсы
    Default = 0,
    PreRecorded = 1,
    // офлайн-курсы
    Offline = 2
}